<!-- Change Date Modal -->
<p-dialog
  [visible]="visible()"
  [resizable]="true"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '960px': '80vw', '640px': '95vw' }"
  [style]="{ width: '500px', 'max-width': '95vw', 'max-height': '90vh' }"
  styleClass="no-header-modal subscription-date-modal"
  [focusOnShow]="false"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <div class="flex flex-column h-full">
      <!-- Header -->
      <div
        class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300 flex-shrink-0"
      >
        <h2 class="mb-0 text-base font-bold">
          {{ 'SUBSCRIPTIONS.DATE_CHANGES.LABLE_EDIT' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closePopup(false)"
        ></div>
      </div>
      <!-- Header -->

      <form
        [formGroup]="EditSubscriptionDatesForm"
        (ngSubmit)="UpdateStartEndDate()"
        class="flex flex-column h-full"
      >
        <!-- Scrollable Content Area -->
        <div
          class="flex-1 overflow-y-auto"
          style="max-height: calc(90vh - 120px)"
        >
          <!-- Content -->
          <div class="surface-100 p-3">
            <div class="flex align-items-center">
              <div class="w-9">
                <div class="mb-3">
                  @if (membershipId() > 0) {
                    <label
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{
                        'SUBSCRIPTIONS.DATE_CHANGES.MEMB_STARTDATE' | translate
                      }}
                    </label>
                  }
                  @if (membershipId() === 0) {
                    <label
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{
                        'SUBSCRIPTIONS.DATE_CHANGES.SUBS_STARTDATE' | translate
                      }}
                    </label>
                  }
                  <p-datepicker
                    [appendTo]="'body'"
                    formControlName="start_date"
                    [showIcon]="true"
                    placeholder="Select Date"
                    inputStyleClass="text-sm"
                    styleClass="w-full text-sm"
                    [maxDate]="
                      canBypassMaxSubscriptionStartDate()
                        ? null
                        : maxSubscriptionStartDate
                    "
                    (onSelect)="OnStartDateChange()"
                  />
                </div>

                <div>
                  @if (membershipId() > 0) {
                    <label
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{
                        'SUBSCRIPTIONS.DATE_CHANGES.MEMB_ENDDATE' | translate
                      }}
                    </label>
                  }
                  @if (membershipId() === 0) {
                    <label
                      class="font-medium text-700 text-xs mb-2 block uppercase"
                    >
                      {{
                        'SUBSCRIPTIONS.DATE_CHANGES.SUBS_ENDDATE' | translate
                      }}
                    </label>
                  }
                  <p-datepicker
                    [appendTo]="'body'"
                    [autofocus]="false"
                    formControlName="end_date"
                    [showIcon]="true"
                    placeholder="Select Date"
                    inputStyleClass="text-sm"
                    styleClass="w-full text-sm"
                    (onSelect)="OnEndDateChange($event)"
                  />
                </div>
              </div>

              <!-- Linked Icon -->
              <div class="ml-5 mt-4 relative">
                <div
                  class="w-2rem h-5rem border-top-1 border-right-1 border-bottom-1 border-300 absolute right-0 top-0 -mt-4 mr-3"
                ></div>
                <div
                  (click)="toggleDateLock(dateLocked)"
                  class="h-2rem w-2rem border-circle surface-300 p-2 flex align-items-center justify-content-center cursor-pointer relative z-1"
                >
                  <i
                    class="fa text-sm"
                    [ngClass]="dateLocked ? 'fa-lock' : 'fa-lock-open'"
                  ></i>
                </div>
              </div>
            </div>
          </div>

          @if (!dateLocked) {
            <div class="-mb-3">
              <p-message
                severity="warn"
                aria-label="subscription-date-lock-message"
              >
                <div class="flex align-items-center w-full">
                  <i
                    class="fa fa-exclamation-triangle mr-2 p-warn text-xl flex-shrink-0"
                  ></i>
                  @if (membershipId() > 0) {
                    <span
                      class="custom-message p-warn text-sm flex-1"
                      [innerHTML]="
                        'SUBSCRIPTIONS.DATE_CHANGES.DATE_LOCK_MSG_MEMB'
                          | translate
                      "
                    ></span>
                  }
                  @if (membershipId() === 0) {
                    <span
                      class="custom-message p-warn text-sm flex-1"
                      [innerHTML]="
                        'SUBSCRIPTIONS.DATE_CHANGES.DATE_LOCK_MSG_SUBS'
                          | translate
                      "
                    ></span>
                  }
                </div>
              </p-message>
            </div>
          }

          <!-- Content -->
          <div class="p-3">
            <label class="font-medium text-700 text-xs mb-2 block uppercase">{{
              'SUBSCRIPTIONS.DATE_CHANGES.CHANGE_REASON' | translate
            }}</label>
            <textarea
              pInputTextarea
              class="w-full h-4rem text-sm"
              formControlName="comment"
              [placeholder]="
                'SUBSCRIPTIONS.DATE_CHANGES.REASON_PALCEHOLDER' | translate
              "
            ></textarea>
          </div>
          <!-- Content -->
        </div>
        <!-- End Scrollable Content Area -->

        <!-- Footer - Fixed at bottom -->
        <div
          class="p-3 flex justify-content-between align-items-center border-top-1 border-300 flex-shrink-0"
        >
          <button
            pButton
            pRipple
            type="button"
            [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
            class="p-button-text text-sm"
            (click)="closePopup(false)"
          ></button>
          <button
            pButton
            pRipple
            type="submit"
            [loading]="isFormSubmitting"
            [label]="'SUBSCRIPTIONS.DATE_CHANGES.BTN_CHANGE_DATE' | translate"
            class="text-sm"
          ></button>
        </div>
        <!-- Footer -->
      </form>
    </div>
  </ng-template>
</p-dialog>
<!-- Change Date Modal -->
